import RfiStatusTag from './RfiStatusTag.component';

export default RfiStatusTag;
